module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('h2', {
    staticClass: "h2t"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/intro#intro"
    }
  }, [_c('span', {
    staticClass: "f3"
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toctitle"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/intro"
    }
  }, [_vm._v("Slow Cooker Love")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01"
    }
  }, [_c('span', {
    staticClass: "f3"
  }, [_vm._v("CHAPTER 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "toctitle"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_vm._v("Vegan Slow Cooker Basics")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch02"
    }
  }, [_c('span', {
    staticClass: "f3"
  }, [_vm._v("CHAPTER 2")])])]), _vm._v(" "), _c('p', {
    staticClass: "toctitle"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch02#ch02"
    }
  }, [_vm._v("No-Time-to-Prep Recipes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f3"
  }, [_vm._v("CHAPTER 3")])])]), _vm._v(" "), _c('p', {
    staticClass: "toctitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Soups")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f3"
  }, [_vm._v("CHAPTER 4")])])]), _vm._v(" "), _c('p', {
    staticClass: "toctitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Stews")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f3"
  }, [_vm._v("CHAPTER 5")])])]), _vm._v(" "), _c('p', {
    staticClass: "toctitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Casseroles & Loaves")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f3"
  }, [_vm._v("CHAPTER 6")])])]), _vm._v(" "), _c('p', {
    staticClass: "toctitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pasta & Grains")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f3"
  }, [_vm._v("CHAPTER 7")])])]), _vm._v(" "), _c('p', {
    staticClass: "toctitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mains")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f3"
  }, [_vm._v("CHAPTER 8")])])]), _vm._v(" "), _c('p', {
    staticClass: "toctitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sides")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f3"
  }, [_vm._v("CHAPTER 9")])])]), _vm._v(" "), _c('p', {
    staticClass: "toctitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sandwich & Taco Fillings")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f3"
  }, [_vm._v("CHAPTER 10")])])]), _vm._v(" "), _c('p', {
    staticClass: "toctitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breads")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f3"
  }, [_vm._v("CHAPTER 11")])])]), _vm._v(" "), _c('p', {
    staticClass: "toctitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Snacks & Appetizers")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f3"
  }, [_vm._v("CHAPTER 12")])])]), _vm._v(" "), _c('p', {
    staticClass: "toctitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Breakfasts")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f3"
  }, [_vm._v("CHAPTER 13")])])]), _vm._v(" "), _c('p', {
    staticClass: "toctitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Desserts")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f3"
  }, [_vm._v("CHAPTER 14")])])]), _vm._v(" "), _c('p', {
    staticClass: "toctitle"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Staples")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appex",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f3"
  }, [_vm._v("APPENDIX")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f3"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/about",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f3"
  }, [_vm._v("ABOUT THE AUTHOR")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "f3"
  }, [_vm._v("INDEX")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ee5fb14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 66
// module chunks = 0